import React, { Fragment } from 'react';
import { ListItemIcon } from "@material-ui/core";
import { PictureAsPdf, Image, LibraryBooks, Directions } from "@material-ui/icons";
// import linkifyUrls from 'linkify-urls';


export class Filters {

  formatMinutes = (minutes) => {
    return minutes > 9 ? minutes : `0${minutes}`;
  }

  formatTime = (time) => {
    const suffix = time.getHours() < 12 ? 'am' : 'pm';
    const hours = time.getHours() % 12 || 12;
    return `${hours}:${this.formatMinutes(time.getMinutes())}${suffix}`;
  }

  formatDate = (date, format) => {
    const daysShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (format === 'long') {
      const daysLong = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      return `${daysLong[date.getDay()]}, ${months[date.getMonth()]} ${date.getDate()}`;
    }
    return `${daysShort[date.getDay()]}, ${months[date.getMonth()]} ${date.getDate()}`;
  }


  startEndDate = (startTs, endTs = startTs) => {
    if(startTs === 0) return null;
    const kamar = (endTs === 'kamar' || endTs === 'ical') ? true : false;
    endTs = kamar ? startTs : endTs;
    const start = startTs + '000';
    const end = endTs + '000';
    const startDate = new Date(parseInt(start, 10));
    const endDate = new Date(parseInt(end, 10));
    const startTime = `${startDate.getHours()}${this.formatMinutes(startDate.getMinutes())}`;
    const endTime = `${endDate.getHours()}${this.formatMinutes(endDate.getMinutes())}`;
    const isSameDay = startTs === endTs;
    const startOfDay = '000';
    const isAllDay = (
      (parseInt(endTs, 10) - parseInt(startTs, 10)) === 86400
      &&
      (startTime === startOfDay && endTime === startOfDay)
    );
    const isSameTime = startTime === endTime;
    if(kamar) {
      return this.formatDate(startDate, 'long');
    }
    if(isSameDay && isSameTime && startTime === startOfDay) {
      return this.formatDate(startDate);
    }
    if(isAllDay) {
      return `${this.formatDate(startDate)} All Day`;
    }
    if(!isAllDay && startTime === startOfDay && endTime === startOfDay) {
      return `${this.formatDate(startDate)} to ${this.formatDate(endDate)}`;
    }
    if(isSameDay && isSameTime) {
      return `${this.formatDate(startDate)}, ${this.formatTime(startDate)}`; //add conditional am/pm 
    }
    if(isSameDay && !isSameTime) {
      return `${this.formatDate(startDate)}, ${this.formatTime(startDate)} - ${this.formatTime(endDate)}`; //add conditional am/pm
    }

    return `${this.formatDate(startDate)}, ${this.formatTime(startDate)} to ${this.formatDate(endDate)}, ${this.formatTime(endDate)}`; //add conditional am/pm
  }

  urlIcon = (url) => {
    const search = url.toLowerCase();
    if(search.indexOf('.pdf') > -1) {
      return <ListItemIcon><PictureAsPdf /></ListItemIcon>;
    } else if(search.indexOf('.doc') > -1 || search.indexOf('.docx') > -1 ) {
      return <ListItemIcon><LibraryBooks/></ListItemIcon>;
    } else if(search.indexOf('.png') > -1 || search.indexOf('.jpg') > -1 || search.indexOf('.jpeg') > -1 ) {
      return <ListItemIcon><Image /></ListItemIcon>;
    } else if(search.indexOf('www.google.co.nz/maps/dir/') > -1) {
      return <ListItemIcon><Directions /></ListItemIcon>;
    } else {
      return null;
    }
  }

  nl2br = (text) => {
    return text ? <this.NewLineToBr>{text}</this.NewLineToBr> : text;
  };

  NewLineToBr = ({ children }) => {
    // console.log(children);
    return children.split('\n').map((line, index) => (
      <Fragment key={index}>
        {/* {this.renderHTMLMarkup(linkifyUrls(this.parseIcalContent(line)))} */}
        {this.renderHTMLMarkup(this.parseIcalContent(line))}
        {/* {this.parseIcalContent(line)} */}
        <br />
      </Fragment>
    ));
  }

  parseIcalContent = (text) => {
    return text ? text.replace(/\\n/g, '<br/>').replace(/\\\\/g, '').replace(/\\/g, '') : text;
  }

  translate = (string, language) => {
    let jsonData;
    try {
      jsonData = JSON.parse(string);
    } catch(e) {
      jsonData = { "en" : string}
    }
    return jsonData[language];
  }

  renderHTMLMarkup = (html) => {
    return <span dangerouslySetInnerHTML={{__html: html}} />;
  }
  
}


// WEBPACK FOOTER //
// ./src/services/Filters.js